import { Box, Skeleton } from "@mui/material";
import { GroupsSwiper, SwiperContainer } from "./PreviewCardSwiper.styles";
import { SwiperSlide } from "swiper/swiper-react";
import { Navigation } from "swiper/modules";
import React from "react";

export function SkeletonsListCards() {
    const MAX_NUMBER_OF_SKELETONS = 4;
    const groupListCollection = [];
    for (let i = 0; i < MAX_NUMBER_OF_SKELETONS; i++) {
        groupListCollection.push(<SkeletonVideoPreview />);
    }

    return (
        <SwiperContainer>
            <GroupsSwiper
                modules={[Navigation]}
                spaceBetween={16}
                watchOverflow={true}
                breakpointsBase={"container"}
                breakpoints={{
                    0: {
                        slidesPerView: 1.6,
                    },
                    358: {
                        slidesPerView: 1.6,
                    },
                    608: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                }}
                direction={"horizontal"}
            >
                {groupListCollection.map((renderedGroup, key) => (
                    <SwiperSlide key={key}>{renderedGroup}</SwiperSlide>
                ))}
            </GroupsSwiper>
        </SwiperContainer>
    );
}

function SkeletonVideoPreview() {
    return (
        <Box sx={{ width: "100%" }}>
            <Skeleton
                variant="rectangular"
                height={300}
                style={{
                    borderRadius: "12px",
                }}
            />
        </Box>
    );
}
